import { shallowRef } from "vue";
import DisplaySettings from "@/modules/explorer/components/SecondaryDrawer/DisplaySettings.vue";
import AddEditCard from "@/modules/dashboards/components/AddEditCard.vue";
import { useBaseStore } from "@/stores/base";
import DataTableDisplaySettings from "../components/SecondaryDrawer/DataTableDisplaySettings.vue";
import AiReport from "@/modules/dashboards/components/AiReport.vue";

export function useExplorerSecondaryDrawer() {
	const componentsMap = {
		DisplaySettings,
		DataTableDisplaySettings,
		AddEditCard,
		AiReport
	};

	type Components = keyof typeof componentsMap;

	const openSecondaryDrawer = (component: Components) => {
		useBaseStore().secondaryDrawerComponent = shallowRef(
			componentsMap[component]
		);
		useBaseStore().showSecondaryDrawer = true;
	};

	return {
		openSecondaryDrawer,
	};
}
